import React from "react";
import { Link } from "react-router-dom";
import { useAuthContext } from "../../../contexts/AuthContext";

// Custom hook to get sidebar items
export const useSidebarItems = () => {
  const { user } = useAuthContext();
  const isAdmin = user?.role === "admin";

  const items = [
    {
      title: "Dashboard",
      path: "/dashboard",
      icon: "📊",
    },
    {
      title: "Content",
      path: "/content",
      icon: "📝",
    },
    {
      title: "SEO",
      path: "/seo",
      icon: "🔍",
    },
    {
      title: "PPC",
      path: "/ppc",
      icon: "💰",
    },
    {
      title: "Social Media",
      path: "/social-media",
      icon: "📱",
    },
    {
      title: "Teams",
      path: "/teams",
      icon: "👥",
    },
  ];

  if (isAdmin) {
    items.push(
      {
        title: "Admin",
        path: "/admin",
        icon: "⚙️",
      },
      {
        title: "Settings",
        path: "/settings",
        icon: "🔧",
      }
    );
  }

  return items;
};
